export class Constanst {
  //Constantes para Configuracion de Parametros
  public static LOCALE_VE = 'es-VE';
  public static LOGO_VISOR_WEB = './assets/img/logo_blanco_visor.png';
  public static LOGO_COLEGIO_INGENIEROS = './assets/img/logo_civ.png';
  public static LOGO_DATALAING = './assets/img/logo_negro.png';
  public static DIALOG_ACTIONBTCANCEL = 'cancelModal';
  public static DIALOG_ACTIONBTACCEPT = 'cancelWithAction';
  public static DIALOG_ACTIONACTIONBTCLOSE = 'cancelAllModals';
  public static DIALOG_RESULT_INFO = 'info';
  public static DIALOG_RESULT_ERROR = 'error';
  public static DIALOG_RESULT_SUCCESS = 'success';
  public static DIALOG_RESULT_ACTION = 'action';
  public static GENERIC_PASSWORD = 'Maprex01.';
  public static RESPONSE_STATUS_ERROR = 'ERROR';
  public static RESPONSE_STATUS_SUCCESS = 'SUCCESS';
  public static REMOTE_USE_CODE = 'remote-code-dtw';
  public static CACHE_NAME_BUDGET_IVA = 'ivaBudget';
  public static CHAPTER_DESCRIPTION_EMPTY = 'C00 - SIN CAPITULO';
  public static PDF_REPORT_PAGE_SIZE = 'LETTER';
  public static PDF_REPORT_INFO_AUTHOR = 'Visor CIV-DL';
  public static PDF_REPORT_INFO_SUBJECT = 'Presupuestos y Control de Obras';
  public static PDF_REPORT_INFO_KEYWORDS = 'DataLaing, Presupuestos, Obras';
  public static PDF_REPORT_INFO_CREATOR = 'Visor CIV-DL';
  public static PDF_REPORT_INFO_PRODUCER = 'Visor CIV-DL';
  public static PDF_REPORT_NAME = 'Visor-CIV-DL-';
  public static PDF_REPORT_HADER_TEXT = 'Colegio de Ingenieros de Venezuela - DataLaing (1.0.0.0)';
  public static PDF_REPORT_FOOTER_ONE = 'Página ';
  public static PDF_REPORT_FOOTER_TWO = ' de ';
  public static PDF_REPORT_LOGO = './assets/img/logo_negro_visor.png';
  public static PDF_REPORT_WATERMARK = './assets/img/logo_civ_marca_agua.png';
  public static PDF_REPORT_NAME_ALL = 'Visor-CIV-DL-Presupuesto-APUs';
  public static PDF_REPORT_NAME_BUDGET = 'Visor-CIV-DL-Presupuesto';
  public static PDF_REPORT_NAME_BUDGET_CHAPTER = 'Visor-CIV-DL-Presupuesto-Capitulos';
  public static PDF_REPORT_NAME_BUDGET_MATERIAL = 'Visor-CIV-DL-Materiales-Presupuesto';
  public static PDF_REPORT_NAME_BUDGET_EQUIPMENT = 'Visor-CIV-DL-Equipos-Presupuesto';
  public static PDF_REPORT_NAME_BUDGET_LABOR = 'Visor-CIV-DL-Mano-de-Obra-Presupuesto';
  public static EXCEL_REPORT_NAME_BUDGET = 'Visor-CIV-DL-Excel-Presupuesto';
  public static APLICAR_IVA_PRESUPUESTO = 'aplicariva';
  public static APLICAR_IVA_APU = 'aplicarapuiva';
  public static APLICAR_IVA_NINGUNO = 'noaplicariva';
  public static CACHE_NAME_BUDGET_OTHERTAX = 'otherTaxBudget';
  public static CACHE_MATERIAL_PRICE_REPLACE = 'materialPriceReplace';
  public static CACHE_LABOR_PRICE_REPLACE = 'laborPriceReplace';
  public static CACHE_EQUIPMENT_PRICE_REPLACE = 'equipmentPriceReplace';
  public static FORMAT_SHORT_DATE = 'dd/MM/yyyy';
  public static IMG_EQUIPMENT_NOT_AVAILABLE = './assets/img/equipoNoDisponible.jpg';
  public static IMG_MATERIAL_NOT_AVAILABLE = './assets/img/materialNoDisponible.jpg';
  //Constantes de Validacion con Expresiones Regulares
  public static REGEXP_EMAIL = "[a-zA-Z0-9!#$%&'*_+-]([\.]?[a-zA-Z0-9!#$%&'*_+-])+@[a-zA-Z0-9]([^@&%$\/()=?¿!.,:;]|\d)+[a-zA-Z0-9][\.][a-zA-Z]{2,4}([\.][a-zA-Z]{2})?";
  public static REGEXP_RIF = "^([VEJPG]{1})([-]{1})([0-9]{1,100}$)";
  public static REGEXP_NUMBERS = "^[0-9]*$";
  public static REGEXP_PASSWORD = "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-.]).{6,15}$";
  public static REGEXP_NOMBRE_ARCHIVO = "^[a-zA-Z0-9](?:[a-zA-Z0-9 _-]*[a-zA-Z0-9]){1}[.][a-zA-Z]{3,}$";
  //Constantes de Mensajes del Sistema
  public static MSG_GENERIC_ERROR = 'Plataforma no disponible. Intente más tarde';
  public static MSG_CONFIRM_USER = '¿Seguro de agregar al usuario?';
  public static MSG_USER_REGISTERED = 'Usuario agregado exitosamente. La clave temporal de ingreso es: ' + this.GENERIC_PASSWORD;
  public static MSG_USER_DELETED_SUCCESS = 'Usuario eliminado exitosamente';
  public static MSG_USERNAME_DOES_NOT_EXIST = 'El usuario no existe o no tiene preguntas de seguridad. Comuníquese con el administrador DataLaing.';
  public static MSG_USER_ALREADY_DELETED = 'El usuario ya se encuentra eliminado';
  public static MSG_CONFIRM_PASSWORD = '¿Está seguro de cambiar su clave?';
  public static MSG_CONFIRM_UPDATE = '¿Está seguro de que desea actualizar el usuario?';
  public static MSG_USER_UPDATED = 'Usuario actualizado exitosamente';
  public static MSG_USER_UPDATED_ERROR = 'Problemas para actualizar el Perfil, intente mas tarde';
  public static MSG_PASSWORD_CHANGED = 'Cambio de contraseña exitoso';
  public static MSG_CONFIRM_BDFILE = '¿Está seguro de cargar el archivo?';
  public static MSG_CONFIRM_DISABLE = '¿Está seguro que desea eliminar el usuario?';
  public static MSG_BDFILE_LOADED = 'Base de Datos en proceso de carga, dentro de unos minutos se completará la actualización.';
  public static MSG_BDFILE_NOSELECTED = 'Seleccione un archivo para cargar';
  public static MSG_BDFILE_NOTYPE = 'Nombre de archivo con extensión inválida';
  public static MSG_CONFIRM_DATEDATA = '¿Está seguro de cambiar la fechas?';
  public static MSG_DATEDATA_CHANGED = 'Fechas cambiadas exitosamente';
  public static MSG_CONFIRM_LOGOUT = '¿Está seguro que desea salir del Visor?'
  public static MSG_CONFIRM_RESET = '¿Está seguro que desea reiniciar al usuario?';
  public static MSG_USER_RESETED = 'Usuario reiniciado exitosamente. La clave temporal de ingreso es: ' + this.GENERIC_PASSWORD;
  public static MSG_INVALID_SESSION = 'Su sesión es inválida. Por seguridad hemos finalizado tu sesión.';
  public static MSG_EXPIRED_SESSION = 'Su sesión ha expirado. Por seguridad hemos finalizado tu sesión por inactividad.';
  public static MSG_002 = 'Usuario y/o contraseña inválidos';
  public static MSG_003 = 'Ya está credencial/licencia se utilizó en otro dispositivo. Por favor, comuníquese con DataLaing si desea ampliar sus licencias.';
  public static MSG_004 = 'Ya existe una conexión activa con sus credenciales. Comuníquese con DataLaing si desea ampliar sus licencias.';
  public static MSG_005 = 'El nombre de usuario ya existe. Por favor, ingrese otro nombre';
  public static MSG_006 = 'Su licencia se encuentra expirada, por favor comuníquese con el administrador de DataLaing.';
  public static MSG_008 = 'Archivo de Base de Datos no encontrado, por favor comuníquese con el administrador de DataLaing.';
  public static MSG_009 = 'Por favor comuníquese con el administrador de DataLaing para reestablecer tus preguntas y respuestas.';
  public static MSG_011 = 'Sus respuestas de seguridad no concuerdan con las registradas en el Visor.';
  public static MSG_012 = 'Este dispositivo/navegador no cuenta con permisos necesarios, por favor comuníquese con el administrador de DataLaing.';
  public static MSG_014 = 'Ya ha sido cargado un archivo de base de datos para el mes en curso, por favor comuníquese con el administrador de DataLaing.';
  public static SCREEN_TYPE_BD = '1';//Partidas
  public static SCREEN_TYPE_PS = '2';//Presupuestos
  public static MSG_GET_COMPANY_ERROR = 'Problemas para obtener lista de empresas.';
  public static MSG_CONFIRM_ADD_COMPANY = '¿Está seguro de que desea agregar la empresa?';
  public static MSG_ADD_COMPANY_ERROR = 'Problemas para agregar la empresa, intente mas tarde.';
  public static MSG_COMPANY_ADDED = 'Empresa agregada exitosamente.';
  public static MSG_CONFIRM_BUDGET = '¿Seguro de agregar el presupuesto?';
  public static MSG_BUDGET_ERROR = 'Problemas para guardar el presupuesto, intente mas tarde.';
  public static MSG_BUDGET_REGISTERED = 'Presupuesto agregado exitosamente.';
  public static MSG_GET_ALLBUDGET_ERROR = 'Problemas para obtener lista de presupuestos.';
  public static MSG_CONFIRM_DELETE_BUDGET = '¿Seguro de borrar el presupuesto?';
  public static MSG_BUDGET_DELETED_SUCCESS = 'Presupuesto eliminado exitosamente';
  public static MSG_DELETE_BUDGET_ERROR = 'Problemas para borrar el presupuesto, intente mas tarde.';
  public static MSG_CONFIRM_UPDATE_BUDGET = '¿Está seguro de que desea actualizar los datos del presupuesto?';
  public static MSG_BUDGET_UPDATED = 'Datos Generales actualizado exitosamente';
  public static MSG_BUDGET_UPDATED_ERROR = 'Problemas para actualizar los datos del presupuesto, intente mas tarde';
  public static MSG_LINEITEM_EMPTY = 'Debes seleccionar un APU para continuar.';
  public static MSG_CONFIRM_EXIT_BUDGET = 'Recuerde guardar los cambios de su presupuesto para no perderlos.\n\n¿Está seguro que desea salir?';
  public static MSG_BUDGET_UPDATED_SUCCESS = 'Presupuesto actualizado exitosamente';
  public static MSG_CONDITIONAPU_UPDATED = 'Condiciones de APU actualizadas exitosamente';
  public static MSG_EMPTY_BUDGET = 'No existen partidas en el presupuesto.';
  public static MSG_VALUE_GREATER_ZERO = 'Valor debe ser mayor a cero (0).';
  public static MSG_CONFIRM_SAVED_BUDGET = 'Se guardarán los cambios de su presupuesto antes de generar el archivo.\n\n¿Está seguro que desea continuar?';
  public static MSG_VALUE_EMPTY = 'Valor no puede ser vacío o en blanco.';
  public static MSG_ERROR_LINEITEM_BUDGET = 'Problemas para cargar las partidas. Recuerde guardar los cambios de su presupuesto antes de generar el archivo.';
  public static MSG_LIMIT_BUDGET_BYUSER = 'Ya alcanzó el límite de presupuesto que puede agregar en Datalaing Web.';
  public static MSG_FILTER_SEARCH_LIMIT = 'Solo se permiten hasta cinco (05) términos a filtrar.';
  public static MSG_COMPANY_EMPTY = 'No posees empresa asociada, por favor comuníquese con el administrador de DataLaing.';
  public static MSG_DOCUMENT_NOT_AVAILABLE = 'Archivo no encontrado. Comuníquese con DataLaing para adquirir información de Complementos.';
  public static STORAGE_DATA_CODE = 'token';
  public static STORAGE_DATA_FIRSTADMISSION = 'firstAdmission';
  public static STORAGE_DATA_USER = 'user';
  public static STORAGE_DATA_PROFILE = 'idProfile';
  public static STORAGE_DATA_USERNAME = 'username';
  public static STORAGE_DATA_CONSULTDATE = 'consultDate';
  public static STORAGE_DATA_SCREENTYPE = 'screenType';
  public static STORAGE_DATA_MONTHCONSULT = 'monthConsult';
  public static STORAGE_DATA_ANIOCONSULT = 'anioConsult';
  public static STORAGE_DATA_USERSELECT = 'idUserSelect';
  public static STORAGE_DATA_BUDGETSELECT = 'idBudget';
}
